module.exports = __webpack_public_path__ + "static/media/DSCF0020.b0ac603c.jpg";